"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FONTS = void 0;
var FONTS = [{
  value: 'Arial, sans-serif',
  label: 'Arial'
}, {
  value: 'Arial Black, sans-serif',
  label: 'Arial Black'
}, {
  value: 'Comic Sans MS, cursive',
  label: 'Comic Sans MS'
}, {
  value: 'Courier New, monospace',
  label: 'Courier New'
}, {
  value: 'Georgia, serif',
  label: 'Georgia'
}, {
  value: 'Impact, sans-serif',
  label: 'Impact'
}, {
  value: 'Times New Roman, serif',
  label: 'Times New Roman'
}, {
  value: 'Trebuchet MS, sans-serif',
  label: 'Trebuchet MS'
}, {
  value: 'Verdana, sans-serif',
  label: 'Verdana'
}];
exports.FONTS = FONTS;